(function () {
  (function initTikTokShowcases() {
    var mediaQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function initShowcase(root) {
      if (!root || root.dataset.ezTiktokInitialized === 'true') return;
      root.dataset.ezTiktokInitialized = 'true';
      var videos = root.querySelectorAll('[data-ez-tiktok-video]');
      if (!videos.length || !('IntersectionObserver' in window)) return;

      var reducedMotion = !!(mediaQuery && mediaQuery.matches);
      function loadVideo(video) {
        if (video.dataset.ezTiktokLoaded === 'true') return;
        video.dataset.ezTiktokLoaded = 'true';
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
        loadObserver.unobserve(video);
      }

      var playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && !reducedMotion) {
            video.muted = true;
            video.play().catch(function () {
              // The always-visible TikTok link and poster remain as the fallback.
            });
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15 });

      var loadObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !reducedMotion) loadVideo(entry.target);
        });
      }, { rootMargin: '280px 0px', threshold: 0 });

      videos.forEach(function (video) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.addEventListener('canplay', function () {
          var bounds = video.getBoundingClientRect();
          if (!reducedMotion && bounds.bottom > 0 && bounds.top < window.innerHeight) {
            video.play().catch(function () {});
          }
        });
        loadObserver.observe(video);
        playObserver.observe(video);
      });

      if (mediaQuery) {
        var onMotionPreferenceChange = function (event) {
          reducedMotion = event.matches;
          videos.forEach(function (video) {
            if (reducedMotion) {
              video.pause();
            } else {
              var bounds = video.getBoundingClientRect();
              if (bounds.bottom > 0 && bounds.top < window.innerHeight) {
                loadVideo(video);
                video.play().catch(function () {});
              }
            }
          });
        };
        if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', onMotionPreferenceChange);
        else if (mediaQuery.addListener) mediaQuery.addListener(onMotionPreferenceChange);
        root._ezTiktokMotionQuery = mediaQuery;
        root._ezTiktokMotionHandler = onMotionPreferenceChange;
      }

      root._ezTiktokPlayObserver = playObserver;
      root._ezTiktokLoadObserver = loadObserver;
    }

    function scan(root) {
      if (root && root.matches && root.matches('[data-ez-tiktok-showcase]')) initShowcase(root);
      if (root && root.querySelectorAll) root.querySelectorAll('[data-ez-tiktok-showcase]').forEach(initShowcase);
    }

    scan(document);
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var roots = [];
      if (event.target && event.target.matches && event.target.matches('[data-ez-tiktok-showcase]')) roots.push(event.target);
      if (event.target && event.target.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(event.target.querySelectorAll('[data-ez-tiktok-showcase]')));
      roots.forEach(function (root) {
        if (root._ezTiktokPlayObserver) root._ezTiktokPlayObserver.disconnect();
        if (root._ezTiktokLoadObserver) root._ezTiktokLoadObserver.disconnect();
        if (root._ezTiktokMotionQuery && root._ezTiktokMotionHandler) {
          if (root._ezTiktokMotionQuery.removeEventListener) root._ezTiktokMotionQuery.removeEventListener('change', root._ezTiktokMotionHandler);
          else if (root._ezTiktokMotionQuery.removeListener) root._ezTiktokMotionQuery.removeListener(root._ezTiktokMotionHandler);
        }
      });
    });
  })();

  // Keep each homepage video's existing volume preference while ramping only
  // silent -> audible transitions. This also observes native media controls.
  window.EZAudioFade = window.EZAudioFade || (function () {
    var DURATION_MS = 1100;
    function clamp(value) {
      value = Number(value);
      if (!isFinite(value)) return 1;
      return Math.max(0, Math.min(1, value));
    }
    function attach(video, onVolumeChange) {
      if (!video) return null;
      if (video._ezAudioFadeController) {
        if (onVolumeChange) video._ezAudioFadeController.onVolumeChange = onVolumeChange;
        return video._ezAudioFadeController;
      }
      var requestFrame = window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : function (callback) { return window.setTimeout(function () { callback(Date.now()); }, 16); };
      var cancelFrame = window.cancelAnimationFrame
        ? window.cancelAnimationFrame.bind(window)
        : window.clearTimeout.bind(window);
      var preferredVolume = clamp(video.volume) || 0.8;
      var frame = null;
      var fading = false;
      var pendingFadeZero = false;
      var targetVolume = preferredVolume;
      var lastMuted = !!video.muted;
      var lastVolume = clamp(video.volume);
      var lastWrittenVolume = lastVolume;
      var onChange = onVolumeChange || null;

      function isSilent() {
        return !!video.muted || clamp(video.volume) <= 0;
      }
      function rememberState() {
        lastMuted = !!video.muted;
        lastVolume = clamp(video.volume);
      }
      function notify() {
        rememberState();
        if (onChange) onChange();
      }
      function cancelFade() {
        if (frame !== null) cancelFrame(frame);
        frame = null;
        fading = false;
        pendingFadeZero = false;
      }
      function finishMutedFade() {
        cancelFade();
        video.volume = targetVolume;
        lastWrittenVolume = targetVolume;
        rememberState();
      }
      function animate(startedAt) {
        if (!fading || video.muted) return;
        var elapsed = Math.max(0, startedAt - animationStart);
        var progress = Math.min(1, elapsed / DURATION_MS);
        video.volume = targetVolume * progress;
        lastWrittenVolume = clamp(video.volume);
        if (progress >= 1) {
          video.volume = targetVolume;
          lastWrittenVolume = targetVolume;
          fading = false;
          frame = null;
          preferredVolume = targetVolume;
          notify();
          return;
        }
        frame = requestFrame(animate);
      }
      var animationStart = 0;
      function fadeIn(volume) {
        targetVolume = clamp(volume) || preferredVolume || 0.8;
        preferredVolume = targetVolume;
        cancelFade();
        fading = true;
        pendingFadeZero = true;
        animationStart = window.performance && window.performance.now
          ? window.performance.now()
          : Date.now();
        video.volume = 0;
        lastWrittenVolume = 0;
        video.muted = false;
        frame = requestFrame(animate);
      }
      function setMuted(muted) {
        if (muted) {
          if (fading) targetVolume = preferredVolume || targetVolume;
          cancelFade();
          video.muted = true;
          video.volume = preferredVolume;
          notify();
          return;
        }
        var chosen = clamp(video.volume) || preferredVolume || 0.8;
        fadeIn(chosen);
        notify();
      }
      function setVolume(volume) {
        var chosen = clamp(volume);
        if (chosen <= 0) {
          if (!isSilent() && !fading) preferredVolume = clamp(video.volume) || preferredVolume;
          cancelFade();
          video.volume = 0;
          video.muted = true;
          notify();
          return;
        }
        preferredVolume = chosen;
        if (isSilent()) {
          fadeIn(chosen);
        } else {
          cancelFade();
          video.muted = false;
          video.volume = chosen;
          notify();
        }
      }
      function toggle() {
        setMuted(!isSilent());
      }
      function handleVolumeChange() {
        var silent = isSilent();
        if (fading) {
          if (video.muted) {
            finishMutedFade();
          } else if (clamp(video.volume) === 0 && pendingFadeZero) {
            pendingFadeZero = false;
          } else if (clamp(video.volume) === 0 && lastVolume > 0) {
            // A native volume slider was moved to zero mid-fade.
            cancelFade();
          } else if (Math.abs(clamp(video.volume) - lastWrittenVolume) > 0.01) {
            // A shopper changed the native volume slider during the ramp.
            cancelFade();
            preferredVolume = clamp(video.volume);
          }
          notify();
          return;
        }
        var wasSilent = lastMuted || lastVolume <= 0;
        if (wasSilent && !silent) {
          fadeIn(clamp(video.volume) || preferredVolume);
          notify();
          return;
        }
        if (video.muted && clamp(video.volume) > 0) {
          // Muting keeps the selected volume, which is the next fade's target.
          preferredVolume = clamp(video.volume);
        } else if (!silent) {
          preferredVolume = clamp(video.volume);
        }
        notify();
      }
      var controller = {
        setMuted: setMuted,
        setVolume: setVolume,
        toggle: toggle,
        cancel: cancelFade,
        isFading: function () { return fading; },
        getPreferredVolume: function () { return preferredVolume; },
        onVolumeChange: onChange
      };
      video._ezAudioFadeController = controller;
      video.addEventListener('volumechange', handleVolumeChange);
      return controller;
    }
    return { attach: attach };
  })();

  var heroMedia = document.querySelector('.ez-hero__media video');
  if (heroMedia) {
    // Keep the poster (video's own first frame): it paints early (good LCP) and
    // the transition into playback is seamless because frame 0 matches it.
    heroMedia.setAttribute('playsinline', '');
    heroMedia.setAttribute('webkit-playsinline', '');
    heroMedia.muted = true;
    heroMedia.loop = true;

    var mediaWrap = document.querySelector('.ez-hero__media');
    var mobileUrl = mediaWrap && mediaWrap.dataset.mobileVideoUrl;

    var heroPlayed = false;
    function tryHeroPlay() {
      if (heroPlayed) return;
      var p = heroMedia.play();
      if (p !== undefined) p.then(function() { heroPlayed = true; }).catch(function() {});
    }

    // Deferred start: the video is rendered with preload="none" and no autoplay
    // attribute so it costs zero bytes before first paint. Once the page has
    // painted (window load, or a short timeout as backstop), swap in the
    // compressed mobile rendition on small screens, then load + play.
    var heroStarted = false;
    function startHeroVideo() {
      if (heroStarted) return;
      heroStarted = true;
      if (mobileUrl && window.innerWidth <= 768) {
        while (heroMedia.firstChild) { heroMedia.removeChild(heroMedia.firstChild); }
        var mSrc = document.createElement('source');
        mSrc.src = mobileUrl;
        mSrc.type = 'video/mp4';
        heroMedia.appendChild(mSrc);
      }
      heroMedia.load();
      tryHeroPlay();
    }

    if (document.readyState === 'complete') {
      startHeroVideo();
    } else {
      window.addEventListener('load', startHeroVideo, { once: true });
      // Backstop: never wait more than 3.5s even if some third-party asset stalls onload
      setTimeout(startHeroVideo, 3500);
    }

    heroMedia.addEventListener('canplay', tryHeroPlay);
    document.addEventListener('touchstart', function () {
      startHeroVideo();
      tryHeroPlay();
    }, { passive: true });
  }

  function closeExistingEzPopup() {
    var existing = document.querySelector('.ez-video-popup');
    if (!existing) return;
    var existingVideo = existing.querySelector('video');
    if (existingVideo) {
      if (existingVideo._ezAudioFadeController) existingVideo._ezAudioFadeController.cancel();
      existingVideo.pause();
    }
    existing.remove();
    document.body.style.overflow = '';
  }

  function openEzPopup(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }
    var template = document.getElementById('ez-video-popup-template');
    if (!template) return false;
    closeExistingEzPopup();
    var popup = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    var video = popup.querySelector('video');
    var closeButtons = popup.querySelectorAll('[data-ez-video-close]');
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (closeEvent) {
        closeEvent.preventDefault();
        closeEvent.stopPropagation();
        closeExistingEzPopup();
      });
    });
    if (video) {
      window.EZAudioFade.attach(video);
      video.currentTime = 0;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(function () {
          if (video.requestFullscreen) {
            video.requestFullscreen().catch(function () {});
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        }).catch(function () {});
      } else {
        if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      }
      video.addEventListener('ended', function () {
        closeExistingEzPopup();
      }, { once: true });
      video.addEventListener('webkitendfullscreen', function () {
        closeExistingEzPopup();
      }, { once: true });
    }
    return false;
  }

  (function() {
    function fmt(s) { s = isFinite(s) ? s : 0; var m=Math.floor(s/60),ss=Math.floor(s%60); return m+':'+(ss<10?'0':'')+ss; }
    function initWrap(wrap) {
      var video = wrap.querySelector('.ez-yt-video');
      var bigBtn = wrap.querySelector('.ez-yt-btn');
      var playBtn = wrap.querySelector('.ez-ctrl-play');
      var seek = wrap.querySelector('.ez-ctrl-seek');
      var timeEl = wrap.querySelector('.ez-ctrl-time');
      var muteBtn = wrap.querySelector('.ez-ctrl-mute');
      var volSlider = wrap.querySelector('.ez-ctrl-vol-slider');
      var shareBtn = wrap.querySelector('.ez-ctrl-share');
      var fsBtn = wrap.querySelector('.ez-ctrl-fs');
      var toast = wrap.querySelector('.ez-ctrl-toast');
      var section = wrap.closest('.ez-solution__inner');
      var soundBtn = section && section.querySelector('.ez-demo-audio');
      var soundLabel = soundBtn && soundBtn.querySelector('span');
      var soundStatus = section && section.querySelector('.ez-demo-audio-status');
      if (!video || !playBtn) return;
      var audioFade = window.EZAudioFade.attach(video, syncVol);
      function setIcon(btn, showCls, hideCls) { var s=btn.querySelector(showCls), h=btn.querySelector(hideCls); if(s)s.style.display=''; if(h)h.style.display='none'; }
      function setSoundStatus(message) { if (soundStatus && message) soundStatus.textContent = message; }
      function syncBigButton() {
        if (!bigBtn) return;
        var isPlaying = !video.paused && !video.ended;
        bigBtn.classList.toggle('ez-yt-hidden', isPlaying);
        bigBtn.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
        bigBtn.tabIndex = isPlaying ? -1 : 0;
      }
      function syncPlay() {
        if (video.paused||video.ended) { setIcon(playBtn,'.ez-ctrl-icon-play','.ez-ctrl-icon-pause'); playBtn.setAttribute('aria-label','Play'); }
        else { setIcon(playBtn,'.ez-ctrl-icon-pause','.ez-ctrl-icon-play'); playBtn.setAttribute('aria-label','Pause'); }
        syncBigButton();
      }
      function syncSeek() {
        var pct = video.duration ? (video.currentTime/video.duration)*100 : 0;
        seek.value = pct; seek.style.setProperty('--pct', pct+'%');
        timeEl.textContent = fmt(video.currentTime)+' / '+fmt(video.duration);
      }
      function syncVol() {
        var v = video.muted ? 0 : video.volume;
        if (volSlider) { volSlider.value = v; volSlider.style.setProperty('--vol', (v*100)+'%'); }
        if (muteBtn) {
          if (v===0) { setIcon(muteBtn,'.ez-ctrl-icon-muted','.ez-ctrl-icon-vol'); muteBtn.setAttribute('aria-label','Unmute'); }
          else { setIcon(muteBtn,'.ez-ctrl-icon-vol','.ez-ctrl-icon-muted'); muteBtn.setAttribute('aria-label','Mute'); }
        }
        if (soundBtn) {
          var soundOn = v > 0 || (!video.muted && audioFade.isFading());
          soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          soundBtn.setAttribute('aria-label', soundOn ? 'Turn sound off for the demo' : 'Turn sound on for the demo');
          if (soundLabel) soundLabel.textContent = soundOn ? 'Turn sound off' : 'Turn sound on';
          setSoundStatus(soundOn
            ? (audioFade.isFading() ? 'Sound is fading in.' : 'Sound is on. Use the sound button to mute the demo.')
            : 'Video is muted. Turn sound on to hear the demo.');
        }
      }
      function syncFs() {
        var fs = !!(document.fullscreenElement || document.webkitFullscreenElement);
        setIcon(fsBtn, fs?'.ez-ctrl-icon-compress':'.ez-ctrl-icon-expand', fs?'.ez-ctrl-icon-expand':'.ez-ctrl-icon-compress');
      }
      if (bigBtn) bigBtn.addEventListener('click', function() {
        var p = video.play();
        if (p && p.catch) {
          p.catch(function() {
            syncBigButton();
            setSoundStatus('The video could not start. Please try again in a moment.');
          });
        }
      });
      playBtn.addEventListener('click', function() {
        if (video.paused||video.ended) {
          var p = video.play();
          if (p && p.catch) p.catch(function() { setSoundStatus('The video could not start. Please try again in a moment.'); });
        } else { video.pause(); }
      });
      seek.addEventListener('input', function() { if(video.duration){video.currentTime=(seek.value/100)*video.duration; seek.style.setProperty('--pct',seek.value+'%');} });
      muteBtn.addEventListener('click', function() { audioFade.toggle(); });
      if (volSlider) volSlider.addEventListener('input', function() { audioFade.setVolume(parseFloat(volSlider.value)); });
      if (soundBtn) soundBtn.addEventListener('click', function() {
        var soundIsOn = !video.muted && video.volume > 0;
        if (soundIsOn) {
          audioFade.setMuted(true);
        } else {
          if (video.volume === 0) audioFade.setVolume(audioFade.getPreferredVolume());
          else audioFade.setMuted(false);
        }
        if (!video.muted && (video.paused || video.ended)) {
          var soundPlay = video.play();
          if (soundPlay && soundPlay.catch) {
            soundPlay.catch(function() {
              syncBigButton();
              setSoundStatus('Sound is enabled, but the video is paused. Press Play demo to start.');
            });
          }
        }
      });
      if (shareBtn) {
        var sheet = null;
        function buildSheet() {
          if (sheet) return;
          var url = window.location.href;
          var enc = encodeURIComponent(url);
          var msg = encodeURIComponent('Check out EZ Slide-On keyrings! ' + url);
          var opts = [
            { label:'Copy Link',  type:'copy',      color:'#0c3b29', href:null,
              icon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>' },
            { label:'Text',       type:'sms',       color:'#2563eb', href:'sms:?&body='+msg,
              icon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>' },
            { label:'Email',      type:'email',     color:'#7c3aed', href:'mailto:?subject='+encodeURIComponent('Check out EZ Slide-On')+'&body='+msg,
              icon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' },
            { label:'WhatsApp',   type:'whatsapp',  color:'#25d366', href:'https://api.whatsapp.com/send?text='+msg,
              icon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>' },
            { label:'Facebook',   type:'facebook',  color:'#1877f2', href:'https://www.facebook.com/sharer/sharer.php?u='+enc,
              icon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>' },
            { label:'X (Twitter)', type:'twitter',  color:'#e7e7e7', href:'https://twitter.com/intent/tweet?text='+encodeURIComponent('Check out EZ Slide-On keyrings!')+'&url='+enc,
              icon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.261 5.632zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>' }
          ];
          sheet = document.createElement('div');
          sheet.className = 'ez-share-sheet';
          sheet.innerHTML = '<div class="ez-share-sheet__title">Share</div><div class="ez-share-sheet__grid">' +
            opts.map(function(o){
              return '<button class="ez-share-option" data-type="'+o.type+'"'+(o.href?' data-href="'+o.href+'"':'')+' style="--sc:'+o.color+'">' +
                '<span class="ez-share-option__icon">'+o.icon+'</span>' +
                '<span class="ez-share-option__label">'+o.label+'</span></button>';
            }).join('') + '</div>';
          wrap.appendChild(sheet);
          sheet.addEventListener('click', function(e) {
            var opt = e.target.closest('.ez-share-option');
            if (!opt) return;
            if (opt.dataset.type === 'copy') {
              function doCopy(){ var t=document.createElement('textarea');t.value=url;t.style.cssText='position:fixed;opacity:0;top:0;left:0';document.body.appendChild(t);t.focus();t.select();try{document.execCommand('copy');}catch(er){}document.body.removeChild(t); }
              if(navigator.clipboard&&window.isSecureContext){navigator.clipboard.writeText(url).catch(doCopy);}else{doCopy();}
              var lbl = opt.querySelector('.ez-share-option__label');
              lbl.textContent = 'Copied!';
              setTimeout(function(){ lbl.textContent = 'Copy Link'; }, 2000);
            } else if (opt.dataset.href) {
              window.open(opt.dataset.href, '_blank', 'noopener,noreferrer');
            }
            closeSheet();
          });
        }
        function openSheet() {
          if (!sheet) buildSheet();
          sheet.classList.add('ez-share-sheet--open');
          shareBtn.setAttribute('aria-expanded','true');
          setTimeout(function(){
            document.addEventListener('click', outsideClose, {once:true, capture:true});
          }, 0);
        }
        function closeSheet() {
          if (!sheet) return;
          sheet.classList.remove('ez-share-sheet--open');
          shareBtn.setAttribute('aria-expanded','false');
        }
        function outsideClose(e) {
          if (sheet && sheet.contains(e.target)) {
            document.addEventListener('click', outsideClose, {once:true, capture:true});
          } else { closeSheet(); }
        }
        shareBtn.setAttribute('aria-expanded','false');
        shareBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (sheet && sheet.classList.contains('ez-share-sheet--open')) { closeSheet(); }
          else { openSheet(); }
        });
      }
      if (fsBtn) fsBtn.addEventListener('click', function() {
        var inFs = document.fullscreenElement || document.webkitFullscreenElement;
        if (inFs) {
          (document.exitFullscreen || document.webkitExitFullscreen).call(document).catch(function(){});
        } else {
          if (wrap.requestFullscreen) {
            wrap.requestFullscreen().catch(function(){});
          } else if (wrap.webkitRequestFullscreen) {
            wrap.webkitRequestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          }
        }
      });
      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
      video.addEventListener('ended', function(){
        video.currentTime = 0;
        video.load();
        syncPlay();
        seek.value = 0; seek.style.setProperty('--pct','0%');
        timeEl.textContent = '0:00 / ' + fmt(video.duration || 0);
        var ctrlBar = wrap.querySelector('.ez-ctrl-bar');
        if (ctrlBar) ctrlBar.classList.remove('ez-ctrl-bar--visible');
        syncBigButton();
      });
      video.addEventListener('error', function() {
        syncBigButton();
        setSoundStatus('The demo video is unavailable right now. Please try again later.');
      });
      video.addEventListener('timeupdate', syncSeek);
      video.addEventListener('volumechange', syncVol);
      video.addEventListener('loadedmetadata', syncSeek);
      document.addEventListener('fullscreenchange', syncFs);
      document.addEventListener('webkitfullscreenchange', syncFs);

      var ctrlBar = wrap.querySelector('.ez-ctrl-bar');
      var hideTimer;
      function showControls() {
        if (!ctrlBar) return;
        ctrlBar.classList.add('ez-ctrl-bar--visible');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function() { ctrlBar.classList.remove('ez-ctrl-bar--visible'); }, 3000);
      }
      wrap.addEventListener('touchstart', function(e) {
        if (e.target.closest('.ez-ctrl-bar')) return;
        if (ctrlBar && ctrlBar.classList.contains('ez-ctrl-bar--visible')) {
          clearTimeout(hideTimer);
          ctrlBar.classList.remove('ez-ctrl-bar--visible');
        } else {
          showControls();
        }
      }, { passive: true });

      if (video.hasAttribute('data-ez-homepage-demo')) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
      }
      syncPlay(); syncVol(); syncSeek();
      if (video.hasAttribute('data-ez-homepage-demo')) {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          setSoundStatus('Video is paused to respect your motion preference. Press Play demo to watch.');
        } else {
          var autoplay = video.play();
          if (autoplay && autoplay.catch) {
            autoplay.catch(function() {
              syncBigButton();
              setSoundStatus('Autoplay is unavailable. Press Play demo to watch, or turn sound on.');
            });
          }
        }
      }
    }
    document.querySelectorAll('.ez-yt-wrap').forEach(initWrap);
  })();

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var directTrigger = target.closest('[data-ez-video-open], .ez-video-trigger');
    var oldAnchorTrigger = target.closest('a[href="#ez-demo"]');
    var textTrigger = target.closest('a, button');
    var isWatchItWork = textTrigger && textTrigger.textContent && textTrigger.textContent.trim().toLowerCase() === 'watch it work';
    if (directTrigger || oldAnchorTrigger || isWatchItWork) {
      openEzPopup(event);
    }
  }, false);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeExistingEzPopup();
  });

  document.addEventListener('shopify:section:unload', closeExistingEzPopup);
})();
